export const props = {
  queryKey: {
    type: String,
    default: ''
  },
  page: {
    type: Number,
    default: () => undefined
  }
}
